var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.5V7.2381C0.5 6.86301 0.646748 6.50484 0.905501 6.24198C1.16399 5.97939 1.51289 5.83333 1.875 5.83333H4.125C4.48711 5.83333 4.83601 5.97939 5.0945 6.24198C5.35325 6.50484 5.5 6.86301 5.5 7.2381V7.5H0.5ZM3 4.07143C2.77129 4.07143 2.54463 4.02568 2.33289 3.93658C2.12113 3.84747 1.9282 3.71665 1.76534 3.5512C1.60245 3.38573 1.47283 3.18886 1.38426 2.97164C1.29569 2.7544 1.25 2.5213 1.25 2.28571C1.25 2.05013 1.29569 1.81703 1.38426 1.59979C1.47283 1.38257 1.60245 1.1857 1.76534 1.02023C1.9282 0.854775 2.12113 0.723956 2.33289 0.634851C2.54463 0.545753 2.77129 0.5 3 0.5C3.46157 0.5 3.90585 0.686193 4.23466 1.02023C4.56374 1.35453 4.75 1.80959 4.75 2.28571C4.75 2.76183 4.56374 3.2169 4.23466 3.5512C3.90585 3.88524 3.46157 4.07143 3 4.07143Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDark);
export default __webpack_public_path__ + "static/media/profile_dark.49a0206393cb2294e0b5544276525605.svg";
export { ForwardRef as ReactComponent };